export default {
	sidebarHeader: 'Nepoužitá data v kampani',
	addedDataForUser: 'Doplňující data',
	emptyDescriptionTitle: 'Některé atributy nemají vyplněný popis',
};
